'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import HeartBgImg from 'assets/images/hearts-region.jpg';
import MoHeartBgImg from 'assets/images/mo-hearts-region.jpg';
import NoHeartBgImg from 'assets/images/no-hearts-region.jpg';
import UIButton from '../atoms/UIButtons/UIButton';
export default function HeartsRegion() {
  const [hasHeartHunters, setHasHeartHunters] = useState(false);
  useEffect(() => {
    const checkHeartHunters = async () => {
      try {
        const res = await fetch('/api/heart-hunters', {
          method: 'GET',
          cache: 'no-store'
        });
        const json = await res.json();
        setHasHeartHunters(json?.success && json?.data?.length > 0);
      } catch {
        setHasHeartHunters(false);
      }
    };
    checkHeartHunters();
  }, []);
  return <div className="relative w-full bg-black">
      <div className={`relative w-full sm:pt-0 ${hasHeartHunters ? 'pt-[275px]' : 'pt-50'} 2xl:pb-[280px] xl:pb-[180px] lg:pb-[140px] sm:pb-15 pb-7.5 flex h-[833px] md:h-[750px] xl:h-[900px] 2xl:h-[1116px] lg:rounded-b-[40px] rounded-b-[16px] overflow-hidden`}>
        <Image src={HeartBgImg} alt="Parade of Hearts - Celebrating art, culture, and connection in the Kansas City region" width="100" height="100" className="object-cover w-full h-full absolute inset-0 sm:block hidden" priority sizes="100vw" />
        <Image src={hasHeartHunters ? MoHeartBgImg : NoHeartBgImg} alt="Parade of Hearts - Celebrating art, culture, and connection in the Kansas City region in mobile" width="100" height="100" className="object-cover object-bottom w-full h-full absolute inset-0 sm:hidden block " priority sizes="100vw" />
        <div className="container-wrap relative z-10 sm:mt-auto flex flex-col">
          <div className="sm:max-w-[372px] max-w-[280px] sm:mx-0 mx-auto sm:text-left text-center">
            <h2 className="2xl:text-[68px] xl:text-[54px] lg:text-[48px] sm:text-[40px] text-[26px] leading-[1em] text-white font-semibold">
              Explore the Hearts
            </h2>
            <p className="text-white/75 lg:text-lg text-base font-normal leading-[1.5] lg:my-6.5 md:my-4 my-2.5">
              Find every heart, from downtown to the neighborhoods that make KC shine
            </p>
          </div>
          <UIButton href="/explore?types=hearts&view=map" variant="primaryTheme" rounded="full" className="!text-base sm:min-w-41 sm:w-fit w-full inline-flex justify-center items-center font-semibold h-12 sm:mt-0 mt-auto">
            Explore Map
          </UIButton>
        </div>
      </div>
    </div>;
}